import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import App from '~app/index';
import { Spinner } from '~components/index';

import reportWebVitals from './reportWebVitals';

import './i18nConfig';
import '~globals/styles/globals.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Suspense fallback={<Spinner />}>
    <App />
  </Suspense>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
